import { TableCell } from "components/table_components/TableCellStyles";
import { parseDateValue } from "lib/columnSort";
import { formatDate } from "lib/utils";

type Props = {
  date: string | null | undefined;
  minWidth: number;
};

export function DateCell({ date, minWidth }: Props) {
  if (!date) return <TableCell minWidth={minWidth}>-</TableCell>;

  const parsedDate = parseDateValue(date);
  return (
    <TableCell minWidth={minWidth}>
      {!parsedDate.isValid ? "-" : formatDate(parsedDate.toJSDate())}
    </TableCell>
  );
}
